window.addEventListener("load", (event) => {
  const tabLabels = document.querySelectorAll(".page-tabs-nav .tab");
  const tabPanes = document.querySelectorAll(".page-tabs-contents .tab-content-wrapper");

  //active underline initial position
  const initActivateTab = document.querySelector(".page-tabs-nav .tab.active");
  const animatedUnderline = document.getElementById("animatedUnderline");
  if (initActivateTab && animatedUnderline) {
    animatedUnderline.style.cssText = `
      left: ${initActivateTab.offsetLeft}px; 
      width: ${initActivateTab.offsetWidth}px;
    `;
  }

  function activateTab(e) {
    e.preventDefault();
    
    // Deactivate all tabs
    tabLabels.forEach(function(label, index){
      label.classList.remove("active");
    });
    tabPanes.forEach(function(pane, index){
      pane.classList.remove("active");
    });
    
    // Activate current tab
    e.target.classList.add("active");
    let clickedTabSelector = e.target.getAttribute("href");
    let clickedTab = document.querySelector(clickedTabSelector);
    if (clickedTab) {
      clickedTab.classList.add("active");
    }

    //active underline position
    if (animatedUnderline) {
      animatedUnderline.style.cssText = `
      left: ${e.target.offsetLeft}px; 
      width: ${e.target.offsetWidth}px;
    `;
    }
  }

  tabLabels.forEach(function(label, index){
    label.addEventListener("click", (event) => {
      activateTab(event);
    });
  });

  //Sticky tabs
  const tabsSections = document.querySelectorAll(".page-tabs-section");

  tabsSections.forEach(function(tabSection) {
    const stickyTabs = tabSection.querySelector(".page-tabs-navigation");
    const stickyTabsWrapper = tabSection.querySelector(".page-tabs-navigation-wrapper");
    if (!stickyTabs || !stickyTabsWrapper) {return}
    document.addEventListener('scroll', function () {
      initStickyTabs(tabSection, stickyTabs, stickyTabsWrapper);
    });
  });

  function initStickyTabs(section, tabs, wrapper) {
    const mainHeader = document.getElementById("shopify-section-header");
    if (!mainHeader) {return}
    const headerHeight = mainHeader.offsetHeight;
    const sectionRect = section.getBoundingClientRect();
    if (!headerHeight || !sectionRect) {return}
    if (sectionRect.top < 0 && sectionRect.bottom > 300) {
      // prevents height of section from changing when tabs are fixed
      wrapper.style.cssText = `height: ${tabs.offsetHeight}px;`;

      tabs.classList.add('sticky');
      tabs.classList.add('wrapper');
      if (mainHeader.classList.contains('sticky-header')) {
        tabs.style.cssText = `top: ${headerHeight - 1}px;`
      } else {
        tabs.style.cssText = "top: 0px;"
      }
    } else {
      tabs.classList.remove('sticky');
      tabs.classList.remove('wrapper');
      tabs.style.cssText = "top: 0px;"

      wrapper.style.cssText = "height: fit-content";
    }
  }

  //Image comparison slider
  const imageComparisonSliders = document.querySelectorAll('[data-component="image-comparison-slider"]');
  imageComparisonSliders.forEach((imageComparisonSlider) => {
    function setSliderstate(e, element) {
      const sliderRange = element.querySelector('[data-image-comparison-range]');
      if (!sliderRange) {return}
      if (e.type === 'input') {
        sliderRange.classList.add('image-comparison__range--active');
        return;
      }
      sliderRange.classList.remove('image-comparison__range--active');
      element.removeEventListener('mousemove', moveSliderThumb);
    }
  
    function moveSliderThumb(e) {
      const sliderRange = document.querySelector('[data-image-comparison-range]');
      const thumb = document.querySelector('[data-image-comparison-thumb]');
      let position = e.layerY - 20;
      if (!sliderRange || !thumb || position) {return}
      if (e.layerY <= sliderRange.offsetTop) {
        position = -20;
      }
      if (e.layerY >= sliderRange.offsetHeight) {
        position = sliderRange.offsetHeight - 20;
      }
      thumb.style.top = `${position}px`;
    }
  
    function moveSliderRange(e, element) {
      const value = e.target.value;
      const slider = element.querySelector('[data-image-comparison-slider]');
      const imageWrapperOverlay = element.querySelector('[data-image-comparison-overlay]');
      if (!value || !slider || !imageWrapperOverlay) {return}
      slider.style.left = `${value}%`;
      imageWrapperOverlay.style.width = `${value}%`;
      element.addEventListener('mousemove', moveSliderThumb);
      setSliderstate(e, element);
    }
  
    function init(element) {
      const sliderRange = element.querySelector('[data-image-comparison-range]');
      if (!sliderRange) {return}
      if ('ontouchstart' in window === false) {
        sliderRange.addEventListener('mouseup', e => setSliderstate(e, element));
        sliderRange.addEventListener('mousedown', moveSliderThumb);
      }
      sliderRange.addEventListener('input', e => moveSliderRange(e, element));
      sliderRange.addEventListener('change', e => moveSliderRange(e, element));
    }
  
    init(imageComparisonSlider);
  });
});